import React from "react";
import "./PopupModal.css"

const PopupModal = ({ isOpen, onClose, content }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h4>متن قوانین</h4>
                    <button onClick={onClose} className="modal-close-btn">
                        &times;
                    </button>
                </div>
                <div className="modal-body"  dangerouslySetInnerHTML={{ __html: content }}>
                    
                </div>
            </div>
        </div>
    );
};

export default PopupModal;